import React from 'react';
import { Button } from '../Button/Button';

import calendarMock from '../../images/calendar-mock.svg';
import circles from '../../images/circles.svg';
import path from '../../images/path.svg';
import battery from '../../images/battery.svg';
import calendar from '../../images/calendar-icon.svg';
import checkCircle from '../../images/check-circle.svg';
import calendar1 from '../../images/calendar-1.svg';
import calendar2 from '../../images/calendar-2.svg';
import calendar3 from '../../images/calendar-3.svg';
import './FullpageScroll.scss';

const FullpageScroll = () => (
  <div className="fullpage-scroll container">
    <div className="fixed col col-6">
      <h1 className="heading">
        Keep your calendar
        <span className="text-gradient"> decluttered</span>
      </h1>
      <div className="imageContainer hidden-mobile">
        <img className="image" src={calendarMock} alt="" />
        <img className="circles" src={circles} alt="" />
        <img className="path" src={path} alt="" />
      </div>
    </div>
    <div className="scrolling col col-6">
      <div className="section">
        <div className="section-data">
          <div className="section-header">
            <img className="icon" src={battery} alt="" />
            <h3 className="sub-heading">Minimize scattered meetings</h3>
          </div>
          <p>
            Aerotime can move meetings on your behalf and stack them to each
            other, removing calendar fragmentation.
          </p>
          <Button type="primary" text="Read more" size="md" />
          <img className="mobile-image" src={calendar1} alt="" />
        </div>
      </div>
      <div className="section">
        <div className="section-data">
          <div className="section-header">
            <img className="icon" src={calendar} alt="" />
            <h3 className="sub-heading">Create healthy new meetings</h3>
          </div>
          <p>Timeslot recommendations to keep you and your team in the flow.</p>
          <p>Agenda recommendations to keep your meetings productive.</p>
          <Button type="primary" text="Read more" size="md" />
          <img className="mobile-image" src={calendar2} alt="" />
        </div>
      </div>
      <div className="section">
        <div className="section-data">
          <div className="section-header">
            <img className="icon" src={checkCircle} alt="" />
            <h3 className="sub-heading">Handle incoming meetings better</h3>
          </div>
          <p>
            Propose better timeslots for meetings that make all attendees more
            productive.
          </p>
          <p>Send quick replies that help in declining meetings with ease.</p>
          <Button type="primary" text="Read more" size="md" />
          <img className="mobile-image" src={calendar3} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default FullpageScroll;
